module.exports = __webpack_public_path__ + "static/shareable-601f5c443637751535bd6a830b6730fd.jpg";